import { type PlaceholderReference } from './types.ts';

export function buildPlaceholderCode(
  field: PlaceholderReference,
  values: Record<string, string | undefined>,
  skipEmpty = false,
): string {
  let code = field.code;
  for (const param of field.parameters) {
    const value = values[param.id];
    const valueStr = value == null ? '' : String(value);
    if (!skipEmpty || valueStr.trim()) {
      code = code.replaceAll(`\${${param.id}}`, () => valueStr);
    }
  }
  return code;
}
